let query = "";
const listeners = new Set();

export const getSearchQuery = () => query;

export const setSearchQuery = (q) => {
  query = q;
  listeners.forEach((l) => l(q));
};

export const subscribeSearch = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
